import React from "react";
import cmsUtils from "../../utils/cmsUtils";
import utils from "../../../utils";
import { SiteLink } from "../../../components";

export function BlogPosts(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};

  //console.log('item', item);

  const posts = getPages(cmsUtils.payload(item, "BlogPosts"));
  const numOfTileLines = parseInt(
    cmsUtils.payload(item, "NumOfTileLines", "2")
  );
  //console.log(numOfPost, parseInt(numOfPost));
  //console.log(posts);
  const bp = utils.ui.getCurrentBreakpoint();
  const tilesPerLine = { xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 };
  const numOfPost = numOfTileLines * (tilesPerLine[bp] || 3);
  const step = numOfPost;
  // console.log("BlogPost:", bp, numOfTileLines, tilesPerLine, numOfPost);

  const [tilesToShow, setTilesToShow] = React.useState(numOfPost);

  const displayingPosts =
    posts.length > tilesToShow ? posts.slice(0, tilesToShow) : posts;
  const showMore = posts.length > displayingPosts.length;

  const pageTileElts = displayingPosts.map((page, index) => (
    <Tile page={page} key={index} disableLink={cmsOption.isCmsEdit}></Tile>
  ));

  const cssClass = utils.classNames(
    "cms_item",
    item.cssClass || item.anchorName || ""
  );

  return (
    <>
      <div
        className={cssClass}
        data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
        id={item.anchorName}
      >
        <div className="blog-tiles">
          {pageTileElts}
        </div>
      </div>
      {showMore && (
        <div className="blog-tiles__loadMore">
          <span
            className="thinBtn"
            onClick={(e) => {
              setTilesToShow(tilesToShow + step);
            }}
          >
            LOAD MORE
          </span>
        </div>
      )}
    </>
  );
}

function getPages(pagesSerialized) {
  if (pagesSerialized) {
    return JSON.parse(pagesSerialized);
  }
  return [];
}

function Tile(props) {
  const page = props.page;
  const imageUrl = utils.site.resourcePath(page.imageUrl);
  const disableLink = props.disableLink;
  const postDate = utils.date.formatDDMMYYYY(page.postDate);
  const categoryName1 = page.categoryName1;
  const categoryName2 = page.categoryName2;
  const categoryName3 = page.categoryName3;

  return (
    <div className="blog-tile">
      <div className="tile-link">
        <div 
          className="bg" 
          style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}
        >
          <div className="details">
            <div className="detail-top">
              <i className="material-icons">calendar_today</i> {postDate}
            </div>
            <div className="detail-middle">
              {(categoryName1 || categoryName2 || categoryName3) && (
                <i className="material-icons" style={{marginRight: "5px"}}>category</i>
              )}
              {categoryName1 && <span className={categoryName2 ? "category" : ""}>{categoryName1}</span>}
              {categoryName2 && <span className={categoryName3 ? "category" : ""}>{categoryName2}</span>}
              {categoryName3 && <span>{categoryName3}</span>}
            </div>
            <div className="detail-btn">
              <SiteLink className="button" to={disableLink ? "" : page.pageUrl}>
                Read More
              </SiteLink>
            </div>
          </div>
        </div>
        
        <SiteLink to={disableLink ? "" : page.pageUrl} style={{height: "100%"}}>
          <div className="postInfo">
            {postDate}
          </div>
          <div className="title">{page.pageTitle}</div>
          {page.tileDesc && <div className="desc">{page.tileDesc}</div>}
        </SiteLink>
      </div>
    </div>
  );
}
